import type { Law } from "../types";

export const ikeaEffect: Law = {
  slug: "ikea-effect",
  title: "IKEA Effect",
  definition: "People value things they helped create more than identical things they did not, even when the help was trivial.",
  category: "psychology",
  color: "#48bb78",
  labels: ["psychology", "product", "economics"],
  copy: [
    "The IKEA effect names the finding that self-assembled furniture is rated more highly than pre-assembled equivalents, and that effort invested in an object inflates its perceived value.",
    "The effect underlies co-creation, personalization, and why users become attached to systems they have configured or customized — with the caveat that the effect depends on the task being completed successfully.",
  ],
  sources: ["https://en.wikipedia.org/wiki/IKEA_effect"],
  related: ["sunk-cost-fallacy", "mere-exposure-effect"],
};
